import React, { Component } from 'react';
import { Route, Router, Switch, withRouter } from 'react-router';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import List from 'views/PagesCreator/List';
import Form from 'views/PagesCreator/Form';
import withRole from 'components/Security/withRole';
import {
  ROLE_CREATE_PAGE,
  ROLE_EDIT_PAGE,
  ROLE_SHOW_PAGE,
} from 'helpers/roles';

class PagesCreator extends Component {
  render() {
    const { props } = this;
    const ListSecured = withRole(ROLE_SHOW_PAGE, List);
    const CreateForm = withRole(ROLE_CREATE_PAGE, Form);
    const EditForm = withRole(ROLE_EDIT_PAGE, Form);
    return (
      <DataGridStateContextProvider>
        <Router history={this.props.history}>
          <Switch>
            <Route
              exact={true}
              path={`${this.props.match.url}/`}
              render={parentProps => <ListSecured {...props} {...parentProps} />}
            />
            <Route
              path={`${this.props.match.url}/add`}
              render={() => <CreateForm {...props} />}
            />
            <Route
              path={`${this.props.match.url}/edit/:id`}
              render={parentProps => <EditForm {...props} {...parentProps} />}
            />
          </Switch>
        </Router>
      </DataGridStateContextProvider>
    );
  }
}

export default withRouter(PagesCreator);
